// rem等比适配配置文件
// 基准大小
const baseSize = 12

// 设置 rem 函数
function setRem() {
  let scale = 0
  if (document.documentElement.clientWidth > 1440) {
    scale = 1
  } else {
    scale = document.documentElement.clientWidth / 1440
  }
  // 当前页面宽度相对于 1440宽的缩放比例，可根据自己需要修改。
  const fontSize = parseInt(baseSize * scale) >= 12 ? parseInt(baseSize * scale) : 12
  // document.documentElement.style.fontSize = parseInt(baseSize * Math.min(scale, 2))+ 'px'
  document.documentElement.style.fontSize = fontSize + 'px'
}
export default function() {
  // 初始化
  setRem()
  // 改变窗口大小时重新设置 rem
  window.onresize = function() {
    setRem()
  }
}
